import script from "./ImageBlockView.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageBlockView.vue?vue&type=script&setup=true&lang=js"

import "./ImageBlockView.vue?vue&type=style&index=0&id=6f56ced3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f56ced3"]])

export default __exports__